/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { get } from 'lodash';
import { isInt } from 'validator';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Autocomplete, Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import axios from '../../services/axios';
import { ContainerGrid, Title } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import * as actions from '../../store/modules/auth/actions';
import HandleEnterKey from '../../components/HandleEnterKey';

dayjs.locale('pt-br');

export default function Cadastro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const today = dayjs();
  const { id } = useParams();
  const userId = useSelector((state) => state.auth.user.id);

  const [descricao, setDescricao] = useState('');
  const [lancamento, setLancamento] = useState(dayjs(today));
  const [id_funcionario, setIdFuncionario] = useState('');
  const [id_motorista, setIdMotorista] = useState('');
  const [id_veiculo, setIdVeiculo] = useState('');
  const [id_carreta, setIdCarreta] = useState('');
  const [id_empresa, setIdEmpresa] = useState('');

  const [tableDataFuncionario, setTableDataFuncionario] = useState([]);
  const [tableDataMotorista, setTableDataMotorista] = useState([]);
  const [tableDataVeiculo, setTableDataVeiculo] = useState([]);
  const [tableDataCarreta, setTableDataCarreta] = useState([]);
  const [tableDataEmpresa, setTableDataEmpresa] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const textData = 'Viagem';
  const tableDatas = 'viagens';

  async function getData() {
    try {
      setIsLoading(true);

      const { data } = await axios.get(`/${tableDatas}/${id}`);
      setDescricao(data.descricao);
      setLancamento(dayjs(data.lancamento));
      setIdFuncionario(data.id_funcionario);
      setIdMotorista(data.id_motorista);
      setIdVeiculo(data.id_veiculo);
      setIdCarreta(data.id_carreta);
      setIdEmpresa(data.id_empresa);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      // navigate(`/${tableDatas}`);
    }
  }

  async function getDataDropdown() {
    try {
      setIsLoading(true);
      let responsekey = await axios.get('/funcionarios');
      setTableDataFuncionario(responsekey.data);

      responsekey = await axios.get('/motoristas');
      setTableDataMotorista(responsekey.data);

      responsekey = await axios.get('/veiculos');
      setTableDataVeiculo(responsekey.data);

      responsekey = await axios.get('/carretas');
      setTableDataCarreta(responsekey.data);

      responsekey = await axios.get('/empresas');
      setTableDataEmpresa(responsekey.data);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/${tableDatas}`);
    }
  }

  async function fetchFuncionario(idUser) {
    try {
      setIsLoading(true);
      const { data } = await axios.get(`/users/${idUser}`); // Endpoint que retorna o usuário logado
      if (data.Funcionario && data.Funcionario.id) {
        setIdFuncionario(data.Funcionario.id); // Define o id_funcionario
      } else {
        toast.error('Funcionário associado ao usuário não encontrado.');
      }
      if (data.Funcionario && data.Funcionario.id_empresa) {
        setIdEmpresa(data.Funcionario.id_empresa); // Define o id_funcionario
      } else {
        toast.error('Empresa associado ao funcionário não encontrado.');
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);
      if (status === 400) errors.map((error) => toast.error(error));
      toast.error('Erro ao buscar funcionário do usuário logado.');
    }
  }

  useEffect(() => {
    async function fetchData() {
      await getDataDropdown();
      if (id) {
        // se for alteração
        await getData();
      }
      await fetchFuncionario(userId); // Passa o userId para a função
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let formErrors = false;

    /* if (!saida || saida === 'NaN') {
      toast.error('Data saída inválido');
      formErrors = true;
    }

    if (!retorno || retorno === 'NaN' || retorno < saida) {
      toast.error('Data retorno inválido');
      formErrors = true;
    }

    if (!isFloat(String(kmsaida))) {
      toast.error(`Valor Km Saída inválido`);
      formErrors = true;
    }

    if (!isFloat(String(kmretorno))) {
      toast.error(`Valor Km Retorno inválido`);
      formErrors = true;
    }

    if (kmretorno < kmsaida) {
      toast.error(`Valor Km Retorno menor que valor Km Saída`);
      formErrors = true;
    } */
    /*
    if (!isFloat(String(consumo))) {
      toast.error('Valor consumo inválido');
      formErrors = true;
    }

    if (!isFloat(String(peso))) {
      toast.error('Valor peso inválido');
      formErrors = true;
    }

    if ((!retorno || !saida) && retorno < saida) {
      toast.error('Data de Retorno menor que Data de Saída');
      formErrors = true;
    }

    if ((!kmretorno || !kmsaida) && kmretorno < kmsaida) {
      toast.error(`Valor Km Retorno menor que valor Km Saída`);
      formErrors = true;
    }
*/
    if (!isInt(String(id_empresa))) {
      toast.error('ID da Empresa inválida');
      formErrors = true;
    }

    if (!isInt(String(id_funcionario))) {
      toast.error('ID do Funcionário inválido');
      formErrors = true;
    }

    if (!isInt(String(id_motorista))) {
      toast.error('ID do motorista inválido');
      formErrors = true;
    }

    if (!isInt(String(id_veiculo))) {
      toast.error('ID do veículo inválido');
      formErrors = true;
    }

    if (formErrors) return;

    try {
      setIsLoading(true);
      if (id) {
        await axios.put(`/${tableDatas}/${id}`, {
          id_empresa: id_empresa || null,
          id_funcionario: id_funcionario || null,
          id_motorista: id_motorista || null,
          id_veiculo: id_veiculo || null,
          id_carreta: id_carreta || null,
          descricao: descricao || null,
        });
        toast.success(`Alterado com sucesso!`);
        navigate(`/${tableDatas}/`);
      } else {
        const response = await axios.post(`/${tableDatas}/`, {
          lancamento: today,
          descricao: descricao || null,
          saida: null,
          retorno: null,
          kmsaida: null,
          kmretorno: null,
          consumo: null,
          peso: null,
          cancelamento: null,
          totaladiantamentos: null,
          totalreceitas: null,
          totaldespesas: null,
          vlicms: null,
          vlpis: null,
          vlcofins: null,
          pericms: null,
          perpis: null,
          percofins: null,
          flag_acerto: 0,
          id_empresa: id_empresa || null,
          id_funcionario: id_funcionario || null,
          id_motorista: id_motorista || null,
          id_veiculo: id_veiculo || null,
          id_carreta: id_carreta || null,
        });
        toast.success(`Cadastrado com sucesso!`);
        navigate(`/controleviagens/${response.data.id}/lancamento`);
      }
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const data = get(err, 'response.data', {});
      const errors = get(data, 'errors', []);

      if (errors.length > 0) {
        errors.map((error) => toast.error(error));
      } else {
        toast.error('Erro desconhecido');
      }

      if (status === 401) dispatch(actions.loginFailure());
    }
  };

  return (
    <ContainerGrid>
      <Loading isLoading={isLoading} />
      <Title>{id ? `Alterar ${textData} Nr. ${id}` : `Nova ${textData}`}</Title>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          '& .MuiTextField-root': { m: 0, width: { xs: '100%', sm: '100%' } },
        }}
      >
        <HandleEnterKey>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="pt-br"
              >
                <DatePicker
                  disabled
                  readOnly
                  slotProps={{
                    textField: {
                      required: true,
                    },
                  }}
                  label="Data Lançamento"
                  size="small"
                  value={lancamento}
                  onChange={(e) => setLancamento(e)}
                  format="DD/MM/YYYY"
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} />
            <Grid item xs={12} sm={6}>
              <Autocomplete
                disabled
                id={id_empresa}
                value={
                  tableDataEmpresa.find((option) => option.id === id_empresa) ||
                  null
                }
                options={tableDataEmpresa}
                getOptionLabel={(option) => option.nome}
                onChange={(event, newValue) => {
                  setIdEmpresa(newValue ? newValue.id : '');
                }}
                renderInput={(params) => (
                  <TextField
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...params}
                    required
                    label="Empresa"
                    size="small"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                disabled
                id={id_funcionario}
                value={
                  tableDataFuncionario.find(
                    (option) => option.id === id_funcionario
                  ) || null
                }
                options={tableDataFuncionario}
                getOptionLabel={(option) => option.nome}
                onChange={(event, newValue) => {
                  setIdFuncionario(newValue ? newValue.id : '');
                }}
                renderInput={(params) => (
                  <TextField
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...params}
                    required
                    label="Funcionário"
                    size="small"
                    variant="outlined"
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Autocomplete
                id={id_motorista}
                value={
                  tableDataMotorista.find(
                    (option) => option.id === id_motorista
                  ) || null
                }
                options={tableDataMotorista}
                getOptionLabel={(option) => option.nome}
                onChange={(event, newValue) => {
                  setIdMotorista(newValue ? newValue.id : '');
                }}
                renderInput={(params) => (
                  <TextField
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...params}
                    required
                    label="Motorista"
                    size="small"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id={id_veiculo}
                value={
                  tableDataVeiculo.find((option) => option.id === id_veiculo) ||
                  null
                }
                options={tableDataVeiculo}
                getOptionLabel={(option) => option.placa}
                onChange={(event, newValue) => {
                  setIdVeiculo(newValue ? newValue.id : '');
                }}
                renderInput={(params) => (
                  <TextField
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...params}
                    required
                    label="Veículo"
                    size="small"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                id={id_carreta}
                value={
                  tableDataCarreta.find((option) => option.id === id_carreta) ||
                  null
                }
                options={tableDataCarreta}
                getOptionLabel={(option) => option.placa}
                onChange={(event, newValue) => {
                  setIdCarreta(newValue ? newValue.id : '');
                }}
                renderInput={(params) => (
                  <TextField
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...params}
                    label="Carreta"
                    size="small"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                value={descricao}
                label="Observação"
                onChange={(e) => setDescricao(e.target.value)}
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="button"
                color="secondary"
                variant="contained"
                onClick={handleSubmit}
              >
                {id ? 'Alterar' : 'Cadastrar'}
              </Button>
              <Button type="button" onClick={() => navigate(`/${tableDatas}`)}>
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </HandleEnterKey>
      </Box>
    </ContainerGrid>
  );
}
